module.exports = __webpack_public_path__ + "static/media/teacher-lessons.f4f6dd9f.png";